module.exports = __webpack_public_path__ + "static/media/ico-faq.523db9bf.svg";